import type { RequestInput } from '../types';

function getUrlPathAndSearch(url: RequestInput): string {
    if (url instanceof URL) {
        return `${url.pathname}${url.search}`;
    }

    const raw = typeof url === 'string' ? url.split('#')[0] : url.url.split('#')[0];

    if (raw.startsWith('http://') || raw.startsWith('https://')) {
        try {
            const parsed = new URL(raw);
            return `${parsed.pathname}${parsed.search}`;
        } catch {
            return raw.split('?')[0];
        }
    }

    return raw;
}

export function isNextApiAuthSignInPost(url: RequestInput, init?: RequestInit): boolean {
    const method = (init?.method ?? 'GET').toUpperCase();
    if (method !== 'POST') {
        return false;
    }

    const pathAndSearch = getUrlPathAndSearch(url);
    if (pathAndSearch.includes('refresh-token')) {
        return false;
    }

    const pathname = pathAndSearch.split('?')[0].replace(/\/$/, '');
    return pathname.includes('/api/') && pathname.endsWith('/auth');
}

export function isIdentityResetPasswordPost(url: RequestInput, init?: RequestInit): boolean {
    const method = (init?.method ?? 'GET').toUpperCase();
    if (method !== 'POST') {
        return false;
    }

    const pathAndSearch = getUrlPathAndSearch(url);
    return pathAndSearch.includes('/authentication/resetPassword');
}
